import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { initializeDB } from '../../config/db';
import { EMPLOYEE_STORE, TEMPS_STORE } from '../../config/constants';

const DBTest = () => {
    const [dbInfo, setDbInfo] = useState(null);

    const testDB = async () => {
        try {
            const db = await initializeDB();
            console.log('DB Test - initialized:', db.name, 'version:', db.version);
            console.log('DB Test - Available stores:', Array.from(db.objectStoreNames));

            // Test employees
            const empTx = db.transaction(EMPLOYEE_STORE, 'readonly');
            const empStore = empTx.objectStore(EMPLOYEE_STORE);
            const allEmployees = await empStore.getAll();
            await empTx.done;

            // Test temps
            const tempTx = db.transaction(TEMPS_STORE, 'readonly');
            const tempStore = tempTx.objectStore(TEMPS_STORE);
            const allTemps = await tempStore.getAll();
            await tempTx.done;

            setDbInfo({
                dbName: db.name,
                dbVersion: db.version,
                stores: Array.from(db.objectStoreNames),
                employeesCount: allEmployees.length,
                tempsCount: allTemps.length,
                firstEmployee: allEmployees[0] ? Object.keys(allEmployees[0]) : [],
                firstTemp: allTemps[0] ? Object.keys(allTemps[0]) : []
            });

            console.log('DB Test - Employees:', allEmployees.length, allEmployees.slice(0, 2));
            console.log('DB Test - Temps:', allTemps.length, allTemps.slice(0, 2));

        } catch (error) {
            console.error('DB Test Error:', error);
            setDbInfo({ error: error.message });
        }
    };

    useEffect(() => {
        testDB();
    }, []);

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>IndexedDB Test</Typography>
            <Button variant="contained" onClick={testDB} sx={{ mb: 2 }}>
                Test DB Again
            </Button>
            
            {dbInfo && (
                <Paper elevation={2} sx={{ p: 2 }}>
                    {dbInfo.error ? (
                        <Typography color="error">Error: {dbInfo.error}</Typography>
                    ) : (
                        <>
                            <Typography><strong>DB Name:</strong> {dbInfo.dbName}</Typography>
                            <Typography><strong>DB Version:</strong> {dbInfo.dbVersion}</Typography>
                            <Typography><strong>Stores:</strong> {dbInfo.stores.join(', ')}</Typography>
                            <Typography><strong>Employees Count:</strong> {dbInfo.employeesCount}</Typography>
                            <Typography><strong>Temps Count:</strong> {dbInfo.tempsCount}</Typography>
                            {dbInfo.firstEmployee.length > 0 && (
                                <Typography><strong>Employee Fields:</strong> {dbInfo.firstEmployee.join(', ')}</Typography>
                            )}
                            {dbInfo.firstTemp.length > 0 && (
                                <Typography><strong>Temp Fields:</strong> {dbInfo.firstTemp.join(', ')}</Typography>
                            )}
                        </>
                    )}
                </Paper>
            )}
        </Box>
    );
};

export default DBTest;